export default __webpack_public_path__ + "assets/images/3.a413a0.avif";